<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-cogs
      </v-icon>
      Ticker Settings List
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="showForm = true"
        >
          <v-icon dark>
            mdi-pencil
          </v-icon>
          create new
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="tickerSettings"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>
              <span v-if="item.name !== null">
                {{ item.name }}
              </span>
              <span v-else>
                N/A
              </span>
            </td>
            <td>{{ item.title }}</td>
            <td>{{ item.position }}</td>
            <td>
              <v-icon
                size="30"
                :color="item.bg_color"
              >
                mdi-rectangle
              </v-icon>
            </td>
            <td>{{ item.direction }}</td>
            <td>{{ item.speed }}</td>
            <td>
              <v-icon
                size="30"
                :color="item.text_color"
              >
                mdi-rectangle
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div>
        <create-ticker-settings
          v-if="showForm"
          @closed="showForm=false"
          @fetch-ticker-settings-list="fetchTickerSettingsList()"
        />
      </div>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import CreateTickerSettings from 'src/views/dashboard/widgets/tickers/CreateTickerSettings.vue';

  export default {
    name: 'TickerSettingsList',
    components: {
      'centre-spinner': spinner,
      'create-ticker-settings': CreateTickerSettings,
    },
    data () {
      return {
        search: '',
        showForm: false,
        headers: [
          { text: 'Name', align: 'start', value: '1' },
          { text: 'Title Position', value: 'position' },
          { text: 'Ticker Position', value: 'position' },
          { text: 'Bg Color', value: 'bg_color' },
          { text: 'Direction', value: 'direction' },
          { text: 'Speed', value: 'speed' },
          { text: 'Text Color', value: 'text_color' },
        ],
        loading: false,
      };
    },
    computed: {
      tickerSettings () {
        return this.$store.getters['widgets/getTickerSettingsList'];
      },
    },
    async mounted () {
      await this.fetchTickerSettingsList();
    },
    methods: {
      async fetchTickerSettingsList () {
        this.loading = true;
        await this.$store.dispatch('widgets/fetchTickerSettingsList');
        this.loading = false;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.v-data-table { background-color: #ECEFF1; }
.font-my-style {
  font-weight: bold;
}
</style>
